export default __webpack_public_path__ + "static/media/eample.8a72ac61.jpg";